// ImpactAnalysisPanel.tsx
import React from 'react';
import { Button, Subtitle2 } from '@fluentui/react-components';
import { BranchCompare20Regular, Dismiss24Regular } from '@fluentui/react-icons';
import { CustomScrollbar } from '@shared/components';
import { useItemScreenStore } from '@modules/items';

export type ImpactAnalysisPanelProps = {
  title: string;
  children: React.ReactNode;
};

const ImpactAnalysisPanel: React.FC<ImpactAnalysisPanelProps> = ({ title, children }) => {
  const { setScreenMode } = useItemScreenStore();

  return (
    <div className="flex flex-col h-full" style={{ width: '300px', minWidth: '300px' }}>
      <div className="pt-3 pl-4 pb-2 pr-3">
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center gap-1">
            <BranchCompare20Regular />
            <Subtitle2>{title}</Subtitle2>
          </div>
          <Button
            appearance="subtle"
            size="small"
            aria-label="close"
            icon={<Dismiss24Regular />}
            onClick={() => setScreenMode()}
          />
        </div>
      </div>
      <CustomScrollbar className="w-full overflow-x-hidden">
        <div className="px-4 pb-4">{children}</div>
      </CustomScrollbar>
    </div>
  );
};

export default ImpactAnalysisPanel;
